<template>
  	<AddPanelSetting />
</template>

<script>

// @ is an alias to /src
import AddPanelSetting from "@/components/Settings/AddPanelSetting.vue";

export default {
  name: "AddPanelSettings",
  components: {
    AddPanelSetting,
  },
};
</script>
